export default "__VITE_ASSET__a7fa4338__"